export const deleteSavedAPIs = (builder) => ({
    deleteSavedAPIs: builder.mutation({
        query: ({ id }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: `/api_integrations/${id}`,
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            }
        },
    }),
});